import React from 'react';
import { Card, CardContent } from '../ui/card';

export const StatCard = ({ title, value, subtitle, icon: Icon, color = "slate" }) => {
  // Dynamic color classes mapping
  const colorClasses = {
    slate: { bg: 'bg-slate-100 dark:bg-slate-700', text: 'text-slate-600 dark:text-slate-300' },
    sky: { bg: 'bg-sky-100 dark:bg-sky-900/50', text: 'text-sky-600 dark:text-sky-400' },
    emerald: { bg: 'bg-emerald-100 dark:bg-emerald-900/50', text: 'text-emerald-600 dark:text-emerald-400' },
    amber: { bg: 'bg-amber-100 dark:bg-amber-900/50', text: 'text-amber-600 dark:text-amber-400' },
    purple: { bg: 'bg-purple-100 dark:bg-purple-900/50', text: 'text-purple-600 dark:text-purple-400' },
    red: { bg: 'bg-red-100 dark:bg-red-900/50', text: 'text-red-600 dark:text-red-400' },
  };

  const colors = colorClasses[color] || colorClasses.slate;

  return (
    <Card className="border-slate-200 dark:border-slate-700">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 dark:text-slate-400">{title}</p>
            <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">{value}</p>
            {subtitle && <p className="text-xs text-slate-400 dark:text-slate-500 mt-1">{subtitle}</p>}
          </div>
          <div className={`w-10 h-10 rounded-lg ${colors.bg} flex items-center justify-center`}>
            <Icon className={`h-5 w-5 ${colors.text}`} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const SimpleBarChart = ({ data, labelKey, valueKey, maxBars = 10 }) => {
  if (!data || data.length === 0) return <p className="text-sm text-slate-400">No data available</p>;
  
  const displayData = data.slice(0, maxBars);
  const maxValue = Math.max(...displayData.map(d => d[valueKey]));
  
  return (
    <div className="space-y-2">
      {displayData.map((item, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="text-xs text-slate-600 dark:text-slate-300 w-24 truncate">{item[labelKey]}</span>
          <div className="flex-1 h-5 bg-slate-100 dark:bg-slate-700 rounded-full overflow-hidden">
            <div 
              className="h-full bg-sky-500 dark:bg-sky-400 rounded-full transition-all duration-500"
              style={{ width: `${(item[valueKey] / maxValue) * 100}%` }}
            />
          </div>
          <span className="text-xs font-medium text-slate-700 dark:text-slate-300 w-8 text-right">{item[valueKey]}</span>
        </div>
      ))}
    </div>
  );
};
